import { combineReducers } from "redux";
import { takeLatest } from "redux-saga/effects";
import { mapPermissions } from "store/state/auth";
import { createSelector } from "reselect";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , makeIsLoadingReducer
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const REMINDER_GET_BY_DEAL = generateDefaultActions("REMINDER_GET_BY_DEAL");
export const reminderGetByDeal = payload => makePayload(REMINDER_GET_BY_DEAL.value, payload);
function* reminderGetByDealSaga(payload) {
  const url = `/notifications/deal/${payload.dealId}`;
  yield requestSaga(REMINDER_GET_BY_DEAL, url, "GET");
}

// REDUCER

const initialState = {
  reminders: []
};

const sortDates = ({ reminders }) => {
  reminders.sort((a, b) => {
    const aDate = new Date(a.testValue);
    const bDate = new Date(b.testValue);

    return aDate - bDate;
  });

  return reminders;
};

function reminderModuleReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case REMINDER_GET_BY_DEAL.success:
      const res = defaultReturn(state, payload.data, "reminders");
      sortDates(res);

      return res;

    default:
      return state;
  }
}

export default combineReducers({
  reminderModuleReducer
});

// SAGA

export function* reminderModuleSaga() {
  yield takeLatest(REMINDER_GET_BY_DEAL.value, reminderGetByDealSaga);
}

// SELECTORS

export const mapModulePermissions = createSelector(mapPermissions, auth => ({
  canViewModule: auth && !auth.isGuest
}));
